import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class LgspService {

	callInstructionPopUpBeforeProfile = false;

	private readonly storageKey = 'formViewFromSideMenu';

	constructor(public http: HttpClient) { }

	// ✅ Save to localStorage
	public setFormViewFromSideMenu(value: boolean): void {
		localStorage.setItem(this.storageKey, JSON.stringify(value));
	}

	// ✅ Get from localStorage
	public getFormViewFromSideMenu(): boolean {
		const storedValue = localStorage.getItem(this.storageKey);
		return storedValue ? JSON.parse(storedValue) : false; // default = false
	}

	public setCallInstructionPopUpBeforeProfile(value: boolean): void {
		this.callInstructionPopUpBeforeProfile = value
	}

	public getCallInstructionPopUpBeforeProfile(): boolean {
		return this.callInstructionPopUpBeforeProfile;
	}

	public deleteDocument(payload): Observable<any> {
		return this.http.post(
			environment.BASE_URL_COMMON + "attachment/deleteByDocumentId",
			payload
		);
	}

	public getAttachmentByDocumentId(payload) {
		return this.http.post(
			environment.BASE_URL_COMMON +
			"attachment/getAttachmentByDocumentId",
			payload
		);
	}

	public uploadDocument(payload): Observable<any> {
		return this.http.post(
			environment.BASE_URL_COMMON + "attachment/uploadDocument",
			payload
		);
	}

	public getDocumentList(payload): Observable<any> {
		return this.http.post(
			environment.BASE_URL_COMMON +
			"attachment/getDocumentByAppIdAndAcronym",
			payload
		);
	}

	public getAppFormData(id): Observable<any> {
		// return this.http.get(
		// 	environment.BASE_URL_LGSP + "lgsp/getApplicationFormData/" + id
		// );
		return this.http.get(
			environment.BASE_URL_LGSP + "lgsp/getApplicationFormData/"
		);
	}
	public saveTestApplicationDetailsData(payload): Observable<any> {
		return this.http.put(
			environment.BASE_URL_LGSP + "lgsp/app/test-details",
			payload
		);
	}


	public saveLgspEducationDetails(payload, educationTypeId: string): Observable<any> {
		if (educationTypeId != '') {
			return this.http.put(
				environment.BASE_URL_LGSP + "lgsp/app/education",
				payload
			);
		} else {
			return this.http.post(
				environment.BASE_URL_LGSP + "lgsp/app",
				payload
			);
		}
	}

	public saveApplicationLGSPData(payload): Observable<any> {
		return this.http.post(
			environment.BASE_URL_LGSP + "lgsp/" + false,
			payload
		);
	}
	

	public saveApplicationLgspInstruction(payload): Observable<any> {
		return this.http.post(
			environment.BASE_URL_LGSP + "lgsp/app",
			payload
		);
	}


	public saveLgspEmploymentDetails(payload): Observable<any> {
			return this.http.put(
				environment.BASE_URL_LGSP + "lgsp/app/employment",
				payload
			);
	}

	public getLgspInstructionPopUpData(): Observable<any> {
		return this.http.get(
			environment.BASE_URL_LGSP + "lgsp/app"
		);
	}


	public submitApplicationDataLGSP(id): Observable<any> {
		return this.http.post(
			environment.BASE_URL_LGSP + "lgsp/app/submit/"  + id,
			''
		);
	}
	public getPaymentEnabledLGSP(id): Observable<any> {
		return this.http.get(environment.BASE_URL_LGSP + 'lgsp/payment-enabled/' + id);
	}
	public getActiveApplication(): Observable<any> {
		return this.http.get(
			environment.BASE_URL_LGSP + "lgsp/isActiveApplications",
		);
	}
	public getBatchId(): Observable<any> {
		return this.http.get(
			environment.BASE_URL_LGSP + "lgsp/getActiveLgspScholarship",
		);
	}

	public downloadApplicationForm(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_COMMON + 'cmn/reportGeneration/HRD/CRHESPB_APPLICATION_FORM/PDF', payload)
	}
}
